import * as types from "./irr-sample.actions"

const initialState = {
  irrSample: {},
  grid: {
    filterModel: null,
    sortModel: null,
    currentPage: null,
  },
  irrReview: {}
}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.IRR_SAMPLE_RETRIEVED:
      console.log("IRR_SAMPLE_RETRIEVED", action.payload)
      return {
        ...state,
        fetching: false,
        irrSample: action.payload
      }

    case types.IRR_SAMPLE_REVIEW_RETRIEVED:
      console.log("IRR_SAMPLE_REVIEW_RETRIEVED", action.payload)
      return {
        ...state,
        fetching: false,
        irrReview: action.payload
      }
    
    case types.IRR_SAMPLE_REVIEWER_REASSIGNED:
      console.log("IRR_SAMPLE_REVIEWER_REASSIGNED", action.payload)
      return {
        ...state,
        irrSample: { ...state.irrSample, irrReviewer: action.payload.reviewer },
      }

    case types.IRR_SAMPLE_REVIEW_SAVED:
      console.log("IRR_SAMPLE_REVIEW_SAVED", action.payload)
      const {q1, q2, q3, q4, q5, comment} = action.payload;
      return {
        ...state,
        irrReview: {...state.irrReview, q1, q2, q3, q4, q4, q5, comment}
      }

    case types.IRR_SAMPLE_CLEARED:
      return { ...initialState }

    case types.IRR_SAMPLE_GRID_FILTER_CHANGED:
      return {
        ...state,
        grid: {
          ...state.grid,
          filterModel: {...action.payload},
        },
      }

    case types.IRR_SAMPLE_GRID_SORT_CHANGED:
      return {
        ...state,
        grid: {
          ...state.grid,
          sortModel: action.payload.map((x) => ({ ...x })),
        },
      }

    case types.IRR_SAMPLE_GRID_PAGINATION_CHANGED:
      return {
        ...state,
        grid: {
          ...state.grid,
          currentPage: action.payload.currentPage,
        },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/modules/irr-sample/irr-sample.reducer.js